export const OfficeFinanceStandardState = {
	url: '/finance-option-standard/:type_id/:id',
	template: '<finance-option-standard></finance-option-standard>',
	params: {id: null, type_id: null, type_name: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFinanceOptionStandardPageMod" */
			'@Containers/office-finance-options/finance-option-standard.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
